export const Domain = 'PRODUCTION';
export const Workspace = {
    "Local": {
        API_Path: "https://teacherlocal.dlearners.in",

    },
    "UAT": {
        API_Path: "https://teacherlocal.dlearners.in",
    },
    "STAGING": {
        API_Path: "https://teacherstaging.dlearners.in",
    },
    "PRODUCTION": {
        API_Path: "https://prod-teacher.dlearners.in",

    }
}